import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { getDriverList, changeDriverDepot } from "../../helpers/api";
import { GET_DRIVER_LIST, CHANGE_DRIVER_DEPOTS } from "./actionTypes";
import { driverListResponce } from "./actions";

//Include Both Helper File with needed methods
import { showToast } from "../toast/actions";




/**
 * Generator function that retrieves a list of depots using the provided token.
 * @param {Object} payload - The payload object containing the token.
 * @param {string} payload.token - The authorization token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* driverList({success, failure}){

  try {
    const responce = yield call(getDriverList)
    if (responce){
      yield put(driverListResponce(responce));
      success(responce)
    }
    
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));
    
  }

}


/**
 * Generator function that handles changing the driver depot.
 * @param {object} payload - The payload object containing the id and data.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* changedriverDepot({ payload: { id, data}, success, failure}){

  try {
    const response = yield call(changeDriverDepot, id, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

function* Driver() {

     yield takeEvery(GET_DRIVER_LIST, driverList);
     yield takeEvery(CHANGE_DRIVER_DEPOTS, changedriverDepot);
   
}

export default Driver;
